import { Action, createActionGroup, emptyProps, props } from "@ngrx/store";

import { ActionSource } from "src/app/state/action-sources";

import { BaseLocationFragment, CalendarEventForScheduleFragment, JobDetailsV2Fragment, Job_CalendarEventFragment } from "../../../../../../generated/graphql.generated";
import { EventLocationTypes, LocationType } from "../../../../../global.constants";
import { JobsV2EventLocation } from "../../../../job-tool.reducer";


export const EventItineraryActions = createActionGroup({
  source: ActionSource.EVENT_ITINERARY,
  events: {
    'Location Dropped': props<{
      previousIndex: number;
      currentIndex: number;
    }>(),
    'Dropdown Location Selected': props<{
      location: JobsV2EventLocation;
      locationId: string;
    }>(),
    'Include Dock Travel Time Checkbox Toggled': props<{ includeDockTravel: boolean }>(),
    'Autocomplete Location Selected': props<{
      location: BaseLocationFragment;
      locationId: string;
      locationType: EventLocationTypes;
    }>(),
    'View Location On Google Maps Button Clicked': props<{ locationType: LocationType }>(),
    'Estimated Time At Location Input Changed': props<{
      duration: number;
      locationId: string;
    }>(),
    'Travel Time To Next Location Input Changed': props<{
      duration: number;
      locationId: string
    }>(),
    'Delete Location Button Clicked': props<{ locationId: string }>(),
    'Add Stop Button Clicked': emptyProps(),
    'Toggle Expand Location Button Clicked': props<{ locationId: string; collapsed: boolean }>(),
    'Location Data Reloaded': props<{
      job: JobDetailsV2Fragment;
      event: Job_CalendarEventFragment;
    }>(),

    'Countdown Started': props<{
      initialCountdown: number;
    }>(),
    'Countdown Ticked': emptyProps(),
    'Countdown Stopped': emptyProps(),
    'Countdown Completed': emptyProps(),

    'Add Location To Job Success': props<{
      updatedJob: JobDetailsV2Fragment;
      locationId: string;
      location: BaseLocationFragment;
    }>(),
    'Add Location To Job Error': props<{
      error: Error;
    }>(),
    'Calculate Now Button Clicked': emptyProps(),
    'Save Event Changes Started': emptyProps(),
    'Save Event Changes Success': props<{
      jobId: string;
      job: JobDetailsV2Fragment;
      updatedEvent: CalendarEventForScheduleFragment;
      promptedBy: Action;
    }>(),
    'Save Event Changes Error': props<{ error: Error }>(),
  }
});
